// import React, { useState } from "react";
// import { Table, Tag, Button, Modal, Select, Collapse, List } from "antd";
import MainLayout from '../../components/layouts/main';
import axios from 'axios';
import Constants from '../../data/constants';
import { connect } from 'react-redux';
import { requestServerGet, requestServerPost, requestWarroomServerPost, requestWarroomServerGet, selectBrand, selectPage, updateGlobalSearch } from '../../actions';

// import styled from "styled-components";

// const { Panel } = Collapse;

// const LicenseManagementContainer = styled.div`
//   padding: 20px;
// `;

// const LicenseTable = styled(Table)`
//   margin-bottom: 20px;
// `;

// const licensesData = [
//   {
//     key: "1",
//     licenseKey: "ABC-123-XYZ",
//     activePeriod: "2024-01-01 to 2025-01-01",
//     maxScreens: 10,
//     usedScreens: 5,
//     status: "Active",
//     screens: ["Screen 1", "Screen 2", "Screen 3", "Screen 4", "Screen 5"],
//   },
//   {
//     key: "2",
//     licenseKey: "DEF-456-UVW",
//     activePeriod: "2024-05-01 to 2024-06-01",
//     maxScreens: 5,
//     usedScreens: 5,
//     status: "Expiring",
//     screens: ["Screen A", "Screen B", "Screen C", "Screen D", "Screen E"],
//   },
// ];

// const LicenseManagement = () => {
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [selectedLicense, setSelectedLicense] = useState(null);
//   const [selectedScreens, setSelectedScreens] = useState([]);

//   const handleAssignScreen = (license) => {
//     setSelectedLicense(license);
//     setIsModalVisible(true);
//   };

//   const handleModalOk = () => {
//     setIsModalVisible(false);
//   };

//   const handleModalCancel = () => {
//     setIsModalVisible(false);
//   };

//   const handleScreenSelect = (value) => {
//     setSelectedScreens(value);
//   };

//   const columns = [
//     {
//       title: "License Key",
//       dataIndex: "licenseKey",
//       key: "licenseKey",
//     },
//     {
//       title: "Active Period",
//       dataIndex: "activePeriod",
//       key: "activePeriod",
//     },
//     {
//       title: "Screens",
//       dataIndex: "screens",
//       key: "screens",
//       render: (_, record) => `${record.usedScreens} / ${record.maxScreens}`,
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       render: (status) => (
//         <Tag color={status === "Active" ? "green" : "orange"}>{status}</Tag>
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (_, record) => (
//         <Button
//           type="primary"
//           disabled={record.usedScreens >= record.maxScreens}
//           onClick={() => handleAssignScreen(record)}
//         >
//           Assign Screens
//         </Button>
//       ),
//     },
//   ];

//   return (
//     <MainLayout id={Constants.LICENSE_PAGE}>
//     <LicenseManagementContainer>
//       <h2>License Management</h2>
//       <LicenseTable columns={columns} dataSource={licensesData} pagination={false} />
//       <Collapse accordion>
//         {licensesData.map((license) => (
//           <Panel header={`License: ${license.licenseKey}`} key={license.key}>
//             <List
//               bordered
//               dataSource={license.screens}
//               renderItem={(screen) => <List.Item>{screen}</List.Item>}
//             />
//           </Panel>
//         ))}
//       </Collapse>
//       <Modal
//         title="Assign Screens to License"
//         visible={isModalVisible}
//         onOk={handleModalOk}
//         onCancel={handleModalCancel}
//       >
//         <p>Select screens to bind to license: {selectedLicense?.licenseKey}</p>
//         <Select
//           mode="multiple"
//           style={{ width: "100%" }}
//           placeholder="Select screens"
//           onChange={handleScreenSelect}
//         >
//           <Select.Option value="screen1">Screen 1</Select.Option>
//           <Select.Option value="screen2">Screen 2</Select.Option>
//           <Select.Option value="screen3">Screen 3</Select.Option>
//         </Select>
//       </Modal>
//     </LicenseManagementContainer>
//     </MainLayout>
//   );
// };

// export default LicenseManagement;
import React, { useEffect, useState } from "react";
import { Collapse, Button, Modal, Select, Table, Tag, Badge, Empty, Spin, notification } from "antd";
import styled from "styled-components";
import { PiPlusCircleFill } from 'react-icons/pi';
import { BsPlusCircleFill } from 'react-icons/bs';
import { BiPlus } from 'react-icons/bi';
import { FaPlus } from 'react-icons/fa6';
import APIManager from '../../managers/APIManager';
import DataHelper from '../../helpers/DataHelper';
import moment from 'moment';
import { THEME_PALLETE } from '../../Theme';

const { Panel } = Collapse;

const LicenseManagementContainer = styled.div`
  padding: 20px;
`;


const ColumnHeader = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const FirstColumnHeader = styled.div`
  flex: 1;
  display: flex;
  justify-content: start;
  align-items: center;
`;


const LicenseManagement = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState(null);
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [licensesData, setLicensesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [screenDatas, setScreenDatas] = useState([]);
  useEffect(() => {
    const { selectedBrandData } = props;
    console.log("LicenseManagement useEffect");
    console.log("selectedBrandData " + JSON.stringify(selectedBrandData))


    if (!selectedBrandData)
      return;

    
    reloadScreens();
    // reloadLicenses();
    // Fetch licenses data from the server or perform any other side effects here
  }, []);


  useEffect(() => {

    console.log("LicenseManagement useEffect screenDatas");
    const { selectedBrandData } = props;
    if (!selectedBrandData)
      return;

    if(!screenDatas)
      return;

    reloadLicenses();
  }, [screenDatas]);


  const reloadScreens = () => {
    const { selectedBrandData } = props;
    console.log("reloadScreens");

    setLoading(true);
    DataHelper.getScreens({ brandid: selectedBrandData.BrandID }, props).then((data) => {
      setScreenDatas(data)
      setLoading(false);

    })
  }
  const reloadLicenses = () => {
    const { selectedBrandData } = props;
    console.log("reloadLicenses");

    setLoading(true);
    APIManager.requestWarroomServerPost("get_licenses", { brand_id: selectedBrandData.BrandID }, {})
      .then((response) => {
        if (response && "data" in response) {
          var licenses = response.data;
          licenses = licenses.map((license) => {  
            if("screens_use" in license)
            {
              license.screens_use = license.screens_use.map((screen) => {
                const screendata = screenDatas.find(s => screen.screen_id == s.ScreenID); 
                if(screendata)
                {
                  screen.LastPublishDate = screendata.LastPublishDate;
                  screen.LastOnline = screendata.LastOnline;
                }
                return screen;
              })
            }
            return license;
          });
          setLicensesData(licenses);
          setLoading(false);
        }

      }
      ).catch((error) => {
        console.log("get_token error " + JSON.stringify(error))
        setLoading(false);
      }
      )
  };

  const handleAssignScreen = (license) => {
    setSelectedLicense(license);
    setIsModalVisible(true);
  };

  const handleModalOk = async () => {
    setIsModalVisible(false);
  
    const selectedScreensData = screenDatas.filter((screen) =>
      selectedScreens.includes(screen.ScreenID)
    );
  
    console.log("selectedScreensData " + JSON.stringify(selectedScreensData));
  
    try {
      for (const screen of selectedScreensData) {
        console.log("selectedScreensData " + JSON.stringify(screen));
        screen.LicenseKey = selectedLicense.license_key;
        console.log("selectedLicense " + JSON.stringify(selectedLicense.license_key));
  
        setLoading(true);
        const response = await APIManager.requestWarroomServerPost(
          "bind_license_screens",
          {
            license_key: selectedLicense.license_key,
            brand_id: screen.BrandID,
            branch_id: screen.BranchID,
            screen_id: screen.ScreenID,
          },
          {}
        );
  
        console.log("bind_screens response " + JSON.stringify(response));
      }
  
      notification.success({
        message: "Screen Binded",
        description: `Successfully binded license for ${selectedScreensData
          .map((d) => d.ScreenName)
          .join(", ")}`,
      });
  
      setLoading(false);
      reloadScreens();
      // reloadLicenses(); // if needed
    } catch (error) {
      console.log("bind_screens error " + JSON.stringify(error));
    }
  };
  

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleScreenSelect = (value) => {
    setSelectedScreens(value);


  };

  const handleUnbindScreen = (record) => {
    console.log("Unbind screen " + JSON.stringify(record))

    Modal.confirm({
      title: "You are about to unbind this screen from the license. Are you sure?",
      // icon: <ExclamationCircleOutlined />,
      onOk() {
        setLoading(true);
        APIManager.requestWarroomServerPost("unbind_license_screens", { licenses_screen_id: record.id, screen_id: record.screen_id }, {})
          .then((response) => {
            console.log("unbind_screens response " + JSON.stringify(response))

            notification.success({
              message: 'Screen Unbinded',
              description:
                `${record.screen_name} has been successfully unbinded`,
            });
            setLoading(false);
            reloadScreens();
          }
          )
      },
      onCancel() {
        console.log('Cancel');
      },
    });


  }


  const columns = [
    { title: "Screen Name", dataIndex: "screen_name", key: "screen_name", render: (text) => text ?? <span style={{color:"#ccc"}}>N/A</span>  },
    { title: "Branch Name", dataIndex: "branch_name", key: "branch_name",align:"center",  render: (text) => text ?? <span style={{color:"#ccc"}}>N/A</span>  },
    { title: "Last Online", dataIndex: "LastOnline", key: "LastOnline", align:"center", render: (text) => text ? <Tag color={THEME_PALLETE.green}>{moment(text).fromNow()}</Tag> : <span style={{color:"#ccc"}}>N/A</span> },
    { title: "Last Published", dataIndex: "LastPublishDate", key: "LastPublishDate", align:"center", render: (text) => text ? <Tag color={THEME_PALLETE.blue}>{moment(text).fromNow()}</Tag> : <span style={{color:"#ccc"}}>N/A</span>  },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button danger onClick={() => handleUnbindScreen(record)}>
          Unbind
        </Button>
      ),
    },
  ];

  return (
    <MainLayout id={Constants.LICENSE_PAGE} showTopBarBrandLogo={true} showSearchBar={true}>
      <LicenseManagementContainer>
        <h2>License Management</h2>

        <Collapse accordion defaultActiveKey={licensesData.length ? licensesData[0].key : undefined}>
          {licensesData.map((license, index) => {
            const remainingScreens = license.screens_slot.length;
            return (
              <Panel
                header={
                  <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                    <FirstColumnHeader>
                      <strong>{license.license_key}</strong>
                    </FirstColumnHeader>

                    <ColumnHeader>
                      {`[${license.screens_use.length}/${license.license_total}]`}
                    </ColumnHeader>
                    <ColumnHeader>
                      {license.license_start_date} - {license.license_end_date}

                    </ColumnHeader>
                    <ColumnHeader>
                      <Tag
                        color={
                          license.license_status.toLocaleLowerCase() === "active"
                            ? "green"
                            : license.license_status.toLocaleLowerCase() === "expired"
                              ? "redorange"
                              : "orange"
                        }
                        style={{ marginLeft: 10 }}
                      >
                        {`${license.license_status}`}
                      </Tag>
                    </ColumnHeader>
                    <ColumnHeader>

                      <Button
                        type="primary"
                        disabled={license.status === "Expired" || remainingScreens <= 0}
                        onClick={(e) => {
                          handleAssignScreen(license);
                           e.stopPropagation()}}
                        style={{ marginLeft: 20, display: "flex", alignItems: "center", gap: "8px" }}
                      >
                        <FaPlus /> Bind Screens
                      </Button>
                    </ColumnHeader>
                  </div>
                }
                key={license.key}
              ><div style={{ padding: "0 20px" }}>

                  <p>Remaining Slots: {remainingScreens}</p>
                  <Table
                    columns={columns}
                    dataSource={license.screens_use}
                    pagination={{ pageSize: 5 }}
                    loading={loading}
                    scroll={{ y: 300, x: "max-content" }}
                    size="small"
                  />
                </div>
              </Panel>
            );
          })}
        </Collapse>

        {/* {loading && (
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Spin size="large" />
          </div>
        )} */}
        {!loading && licensesData.length === 0 && (
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Empty description="No Licenses Found" />
          </div>
        )}
        <Modal
          title="Assign Screens to License"
          open={isModalVisible}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
        >
          <p>Select screens to bind to license: {selectedLicense?.licenseKey}</p>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Select screens"
            onChange={handleScreenSelect}
          >
            {
              screenDatas.filter(dat => { return !("LicenseKey" in dat) }).map((screen) => {
                console.log("screen " + JSON.stringify(screen))
                return <Select.Option key={screen.ScreenID} value={screen.ScreenID}>
                  {screen.ScreenName}
                </Select.Option>
              })
            }
          </Select>
        </Modal>
      </LicenseManagementContainer>
    </MainLayout>
  );
};


const mapStateToProps = (state) => {
  return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, requestWarroomServerPost, requestWarroomServerGet, selectBrand, selectPage })(LicenseManagement);